/**
 * List of note presets
 */
export function getNotePresets(): string[] {
  return [
    'Emailed client',
    'Emailed custody',
    'Custody confirmed',
    'Failed trade',
    'Immaterial',
    'Mirrors price movement',
    'Old error',
    'Pending transaction',
    'Resolve until settle',
    'Waiting on custody',
    "Won't pay",
    'Logged',
    '3 days to clear',
    '1 day to clear',
    'Within tolerance',
  ]
}
